export default {"src":"/_next/static/media/ico-pdf.28305781.svg","height":32,"width":25,"blurWidth":0,"blurHeight":0};